// extracted by mini-css-extract-plugin
export default {"blogPage":"Blog_blogPage__NAvJy","headerWrapper":"Blog_headerWrapper__c4o9D"};